import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VModal from 'vue-js-modal'
 
Vue.use(VModal)

Vue.config.productionTip = false

new Vue({
  router,
  data: {
    imgPath: 'image path', // visible to template
    imgText: 'image text',
    imgName: 'image name'
},
  render: h => h(App)
}).$mount('#app')
